/**
 * 找回密码流程接口共7个
 * - 判断用户信息是否与预留一致 并发送验证码 /customerV2/forgetPwdSendCode
 * - 判断用户信息是否与预留一致 校验验证码 /customerV2/forgetPwdCheckCode
 * - 判断用户信用卡信息是否与预留一致 并发送验证码 /customerV2/forgetPwdSendCode4OnlyCC
 * - 判断用户信用卡信息是否与预留一致 校验验证码 /customerV2/forgetPwdCheckCode4OnlyCC
 * - 没有身份信息 发送短信验证码找回密码 /customerV2/forgetPwdSendCodeNoId
 * - 没有身份信息 核对短信验证码找回密码 /customerV2/forgetPwdCheckCodeNoId
 * - 获取澳觅手机号 /customerV2/getAomiPhone
 *
 * - 设置新密码 /customer/setNewPassword
 * - 获取找回密码银行列表 找回密码页面的银行下拉选项 /paramConfig/queryFindPwdBank
 * - 获取找回密码银行列表-无身份证的渠道 /paramConfig/queryFindPwdBankNoId
 */
import fetch from '@/utils/fetch/index'

export interface SendFindPwdInfo {
  /** 银行编号02大丰 */
  bankNo: string
  /** 卡号 */
  cardNo: string
  /** 证件号码 */
  idNo?: string
  /** 证件类型 */
  idType?: string
  /** 英文姓名？ */
  name?: string
  /** 生日 */
  birthday?: string
}

export interface ValidFindPwdInfo extends SendFindPwdInfo {
  code: string
}

export interface SendFindPwdCard {
  /** 绑卡渠道 */
  bankNo?: string
  /** 卡号 */
  cardNo: string
  /** 有效期 */
  expiryDate?: string
  /** 英文姓名？ */
  name?: string
  /** 手机号 */
  phone: string
  /** 手机区号，bankNo 02时必输，0086，00853，00852 */
  phoneArea?: string
}

export interface ValidFindPwdCard extends SendFindPwdCard {
  code: string
}

/**
 * 判断用户信息是否与预留一致 发送找回密码的短信
 * @param params
 * @returns
 */
export function sendFindPwdSms(params: SendFindPwdInfo) {
  return fetch('/customerV2/forgetPwdSendCode', {
    params,
  })
}

/**
 * 判断用户信息是否与预留一致 校验找回密码所需的所有信息
 * @param params
 * @returns
 */
export function validFindPwdInfo(params: ValidFindPwdInfo) {
  return fetch('/customerV2/forgetPwdCheckCode', {
    params,
  })
}

/**
 * 判断用户信用卡信息是否与预留一致 并发送验证码
 * @param params
 * @returns
 */
export function sendFindPwdSmsWhenOnlyBindVM(params: SendFindPwdCard) {
  return fetch('/customerV2/forgetPwdSendCode4OnlyCC', {
    params,
  })
}

/**
 * 判断用户信用卡信息是否与预留一致
 * @param params
 * @returns
 */
export function validFindPwdWhenOnlyBindVm(params: ValidFindPwdCard) {
  return fetch('/customerV2/forgetPwdCheckCode4OnlyCC', {
    params,
  })
}

/**
 * 未绑卡时找回密码发送短信
 * @returns
 */
export function sendFindPwdSmsWhenNoCard() {
  return fetch('/customerV2/forgetPwdSendCodeNoId')
}

/**
 * 未绑卡时找回密码验证信息
 * @param params
 * @returns
 */
export function validFindPwdInfoWhenNoCard(params) {
  return fetch('/customerV2/forgetPwdCheckCodeNoId', {
    params,
  })
}

/**
 * 获取用户手机号 用于找回密码
 * @returns
 */
export function getUserPhone() {
  return fetch('/customerV2/getAomiPhone')
}

/**
 * 设置新密码
 * @param params
 * @returns
 */
export function setNewPayPwd(params) {
  return fetch('/customer/setNewPassword', {
    params,
  })
}

/**
 * 获取找回密码银行列表 找回密码页面的银行下拉选项
 * @param params
 * @returns
 */
export function queryFindPwdBank(params) {
  return fetch('/paramConfig/queryFindPwdBank', {
    params,
  })
}

/**
 * 获取找回密码银行列表-无身份证的渠道
 * @returns
 */
export function queryFindPwdBankNoId() {
  return fetch('/paramConfig/queryFindPwdBankNoId')
}

/**
 * 清除支付密码
 * @returns
 */
export function deletePwd() {
  return fetch('/test/delPwd')
}

/**
 * 小程序首次登录发短信
 * - 这个接口是不用走验签的
 * @returns
 */
export function sendLoginSms() {
  return fetch('/customerV2/sendSecSMSCode')
}

/**
 * 小程序获取澳觅手机号码
 * - 这个接口是不用走验签的
 * @returns
 */
export function getSecAomiPhone() {
  return fetch('/customerV2/getSecAomiPhone')
}
